import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=5b414607&"
import script from "./Journal.vue?vue&type=script&lang=js&"
export * from "./Journal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports